import React from 'react';
import {Utils} from '../util/utils'

 class ColorComp extends React.Component {
     
     /**on color button enter key press - for accessibility */
    onColorBtnEnterPress = (e,btnId) => {
        
        let currentElementId;
        if (e.keyCode === 38 || e.keyCode ===39) {
            if(document.getElementById(btnId) &&  document.getElementById(btnId).nextElementSibling){
                currentElementId = document.getElementById(btnId).nextElementSibling.id;
                
            }
        }else if (e.keyCode === 37|| e.keyCode ===40) {
            if(document.getElementById(btnId) &&  document.getElementById(btnId).previousElementSibling){
                currentElementId = document.getElementById(btnId).previousElementSibling.id;
            }
        }
        if(currentElementId){
            let currentProductId = currentElementId.split('_');
            if(currentProductId && currentProductId.length && currentProductId[3]){ 
              
                setTimeout(() => {
                    document.getElementById(currentElementId).focus();
                this.props.colorSelection(this.props.groupId,currentProductId[3],currentElementId,e);
                //if(e.currentTarget !== document.activeElement){
                    document.getElementById(currentElementId).focus();
               // }
               
            }, 10);
            }
            
        }
       
        
       };  
      
  render() {
    
    let colorList = [];
    let selectedColor = '';
    let styleColor = [];
    let textColor='';
    let lytColor=[];
    let darkColor=[];
    let color
    let prodcolor
    this.props.itemValue.map((itemValue, index) => {
        if(itemValue.color){
            prodcolor=itemValue.color.replace(/\s/g, '')
            }
            else{
             prodcolor=itemValue.color
            }
        if (this.props.itemValue.length === 1) {
            if (Utils.isNotNull(itemValue.color)) {
                 color=itemValue.color
                    lytColor=['Chalk','Lilac','Slate','White']
                    darkColor=['Charcoal','Black','Blue','Gray','Grey','Silver']
                     lytColor.map((colorLyt,index)=>{
                        if(colorLyt===color){
                            textColor=".bg-white"
                        }
                        return "";
                    })
                    darkColor.map((colorDark,index)=>{
                        if(colorDark===color){
                            textColor="text-white"
                        }
                        return "";
                    })
                   
                selectedColor = ( "product-color bg-"+ prodcolor.toLowerCase() + " active " + textColor)
                styleColor = itemValue.color;
            }
        }
        else if (this.props.itemValue.length > 1) {
            if (Utils.isNotNull(itemValue.color)) {
                 color=itemValue.color
                    lytColor=['Chalk','Lilac','Slate','White']
                    darkColor=['Charcoal','Black','Blue','Gray','Grey','Silver']
                    lytColor.map((colorLyt,index)=>{
                    if(colorLyt===color){
                        textColor=".bg-white"
                    }
                    return "";
                })
                darkColor.map((colorDark,index)=>{
                    if(colorDark===color){
                        textColor="text-white"
                    }
                    return "";
                })
                
                selectedColor = (this.props.selectedValue.productId === itemValue.productId ? ( " product-color  bg-" + prodcolor.toLowerCase() +" active " +textColor) : ( "product-color bg-" + prodcolor.toLowerCase() ))
                styleColor = itemValue.color;
            }
        }
        if (Utils.isNotNull(selectedColor) && selectedColor!=="") {
            colorList.push(
                
                <li  key={'key'+itemValue.productId} tabindex={(this.props.selectedValue.productId === itemValue.productId) ?'0': '-1'}  role="radio" id ={'prod670040_sku830084_sku_'+itemValue.productId} onKeyDown={(e) => {e.stopPropagation();this.onColorBtnEnterPress(e,'prod670040_sku830084_sku_'+itemValue.productId)}} className={selectedColor}  style={{ backgroundColor: styleColor, float:'left'}}  title={styleColor} aria-label={(this.props.selectedValue.productId === itemValue.productId) ? styleColor + ' Color Selected': styleColor + ' Color'} onClick={(e) => { this.props.colorSelection(this.props.groupId, itemValue.productId) }} aria-checked={(this.props.selectedValue.productId === itemValue.productId) ? true: false}></li> 
                    

            )
        }
        return "";
    })
      
    return (   
        <React.Fragment>
            <span onClick={(e)=>{e.stopPropagation();}}>
               {(colorList && colorList.length > 0) ? <ul role="radiogroup" aria-label={this.props.itemValue[0].name} className="no-bullet" data-product-color="" >
                {colorList}
                </ul> : ""}
                 
                     
                 </span>
            </React.Fragment>       
      
    );
  }
}
export default ColorComp;